<template>
  <div id="app">
    <mew-header />
    <div class="container">
      <router-view/>
    </div>
    <mew-footer />
  </div>
</template>

<script>
  import mewHeader from './mew-header'
  import mewFooter from './mew-footer'

  export default {
    name: 'default',
    components: {
      mewHeader,
      mewFooter
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @media screen and (max-width: 768px)
    .container
      padding-top 60px
</style>
